import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/', // 请求路由路径
    redirect: '/home' // 重定向
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/rent',
    name: 'rent',
    component: () => import('../views/RentView.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/Product.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
